import React from 'react';

const AlgorithmDetails = ({ algorithmInfo, isLoadingAlgorithms }) => {
  return (
    <div className="algorithm-details">
      {isLoadingAlgorithms ? (
        <p>Loading algorithm information...</p>
      ) : (
        <>
          <h5>{algorithmInfo.name}</h5>
          <p className="algorithm-description">{algorithmInfo.description}</p>
          <div className="algorithm-principle">
            <h6>Algorithm Principle:</h6>
            <p>{algorithmInfo.principle}</p>
          </div>

        </>
      )}
    </div>
  );
};

export default AlgorithmDetails; 